import { isEmpty } from '@sgme/fp';
import { useWorkflowErrorsUtils } from 'hooks/useWorkflowErrorsUtils';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

interface WorkflowErrorSummaryBaseProps {
  workflowErrors: readonly NextWorkflowError[];
  defaultErrorMessage?: string;
}
export type WorkflowErrorSummaryProps = WorkflowErrorSummaryBaseProps &
  (
    | { shouldUseRejectionCode: true; productSubtype: string }
    | { shouldUseRejectionCode: boolean; productSubtype?: string }
  );

// TODO: unit test by react-testing-library
export const WorkflowErrorSummary: FC<WorkflowErrorSummaryProps> = ({
  workflowErrors,
  productSubtype,
  shouldUseRejectionCode,
  defaultErrorMessage,
}) => {
  const { formatMessage } = useIntl();
  const { getFormattedWorkflowErrorsSummary } = useWorkflowErrorsUtils();

  const formattedSummaryMessages = useMemo(
    () => getFormattedWorkflowErrorsSummary(workflowErrors, shouldUseRejectionCode, productSubtype),
    [workflowErrors, productSubtype, shouldUseRejectionCode, getFormattedWorkflowErrorsSummary],
  );

  return (
    <>
      {isEmpty(workflowErrors) ? (
        <h6 title={formatMessage({ id: 'errors' })}>
          {defaultErrorMessage ?? formatMessage({ id: 'anErrorOccurred' })}
        </h6>
      ) : (
        <ul className="m-0 p-0" data-e2e="errors-panel-errors-summary" title={formatMessage({ id: 'errors' })}>
          {formattedSummaryMessages.map(msg =>
            msg.map((line, lineIndex) => (
              <li className="fw-bold" key={lineIndex} style={{ listStyle: 'none' }}>
                <i className="icon icon-sm me-2">cancel</i>
                <span className="mt-1 text-break">{line}</span>
              </li>
            )),
          )}
        </ul>
      )}
    </>
  );
};
